import { Text, Tooltip } from "@chakra-ui/react";
import React, { useMemo, useCallback } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import { IconTwitter, IconLI, IconYT } from "../../../../../styles/icons";
import { SelectInput, TextInput } from "../../../../components/forms";
import { FaTiktok, FaInstagram } from "react-icons/fa";
import { InfoIcon } from "@chakra-ui/icons";
import { useUtilityData } from "../../../../utilities/contexts";
import { updateProfileValue } from "../../../../redux/actions/user";
import AddressSearch from "react-loqate";
import { Input } from "@headlessui/react";
import { searchListComponents } from "../common-screens/EditSectionSessionType";
import { FormItemTitle } from "../FormItemTitle";

const regexURL =
  /^((ftp|http|https):\/\/)?(www.)?(?!.*(ftp|http|https|www.))[a-zA-Z0-9_-]+(\.[a-zA-Z]+)+((\/)[\w#]+)*(\/\w+\?[a-zA-Z0-9_-]+=\w+(&[a-zA-Z0-9_-]+=\w+)*)?$/gm;
const phoneRegExp =
  /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

const contactData = [
  {
    label: "Name",
    fieldName: "fullname",
    fieldType: "text",
    placeholder: "John Roberts",
    required: true,
  },
  {
    label: "Contact email",
    fieldName: "email",
    fieldType: "email",
    placeholder: "e.g. john@yourmail.com",
    required: true,
    tooltip: "To change this email, please contact info@welldoing.org",
    disabled: true,
  },
  {
    label: "Contact number",
    fieldName: "practiceNumber",
    fieldType: "phone",
    placeholder: "(01234) 567890",
    required: true,
    tooltip:
      "This will not show up on your public profile but will allow Welldoing support to contact you if neccessary.",
  },
  {
    label: "Website",
    fieldName: "website",
    fieldType: "text",
    placeholder: "http://www.yoursite.com",
    isLinks: true,
  },
];

const linksData = [
  {
    label: "LinkedIn",
    fieldName: "linkedIn",
    fieldType: "text",
    placeholder: "e.g. https://www.linkedin.com/mypractice",
    icon: <IconLI color="#0072B1" />,
  },
  {
    label: "YouTube",
    fieldName: "youTube",
    fieldType: "text",
    placeholder: "e.g. https://www.youtube.com/mypractice",
    icon: <IconYT color="#c4302b" />,
  },
  {
    label: "X (Formerly Twitter)",
    fieldName: "x",
    fieldType: "text",
    placeholder: "e.g. https://x.com/mypractice",
    icon: <IconTwitter color="black" />,
  },
  {
    label: "TikTok",
    fieldName: "tiktok",
    fieldType: "text",
    placeholder: "e.g. https://tiktok.com/mypractice",
    icon: <FaTiktok color="black" />,
  },
  {
    label: "Instagram",
    fieldName: "instagram",
    fieldType: "text",
    placeholder: "e.g. https://instagram.com/mypractice",
    icon: <FaInstagram color="black" />,
  },
];

const ProfileContactForm = (props) => {
  const { profile } = props;
  const utilityData = useUtilityData();
  const user = useSelector((state) => state.user.userDetails);

  const [contactAddress, setContactAddress] = useState(
    profile.contactAddress.locationId
      ? {
          Line1: profile.contactAddress.address,
          Line2: "",
          Line3: "",
          City: profile.contactAddress.city,
          PostalCode: profile.contactAddress.postcode,
        }
      : null,
  );

  const xURL = useMemo(
    () =>
      profile.links
        ? profile.links.filter((el) => el.type === "x")[0]?.url
        : null,
    [profile],
  );
  const linkedInURL = useMemo(
    () =>
      profile.links
        ? profile.links.filter((elem) => elem.type === "linkedIn")[0]?.url
        : null,
    [profile],
  );
  const youTubeURL = useMemo(
    () =>
      profile.links
        ? profile.links.filter((elem) => elem.type === "youTube")[0]?.url
        : null,
    [profile],
  );
  const tiktokURL = useMemo(
    () =>
      profile.links
        ? profile.links.filter((elem) => elem.type === "tiktok")[0]?.url
        : null,
    [profile],
  );
  const instagramURL = useMemo(
    () =>
      profile.links
        ? profile.links.filter((elem) => elem.type === "instagram")[0]?.url
        : null,
    [profile],
  );
  const websiteURL = useMemo(
    () =>
      profile.links
        ? profile.links.filter((elem) => elem.type === "website")[0]?.url
        : null,
    [profile],
  );

  const [urls, setUrls] = useState(profile.links);

  const dispatch = useDispatch();

  const handleProfileValueUpdate = useCallback(
    (key, value, isLinks = false) => {
      if (isLinks) {
        const newLinks = [
          {
            url: value.url,
            type: value.fieldName,
            name: value.label,
          },
        ].concat(urls.filter((link) => link.type !== value.fieldName));
        setUrls(newLinks);
        dispatch(updateProfileValue("links", newLinks));
      } else {
        dispatch(updateProfileValue(key, value));
      }
    },
    [dispatch, urls],
  );

  const loqateSearchAddress = async (search) => {
    let buildUrl =
      "https://api.addressy.com/Geocoding/International/Geocode/v1.10/json3.ws";
    buildUrl += `?Key=${encodeURIComponent(process.env.NEXT_PUBLIC_LOQATE_APIKEY)}`;
    buildUrl += "&Country=gb";
    buildUrl += `&Location=${encodeURIComponent(`${search.Line1} ${search.City} ${search.PostalCode}`)}`;
    const res = await fetch(buildUrl, {
      method: "POST",
      headers: {
        "Content-type": "application/json",
      },
    });
    const body = await res.json();
    if (body.Items.length === 0) {
      return;
    }

    dispatch(
      updateProfileValue("contactAddress", {
        address: `${search.Line1}${search.Line2 !== "" ? `, ${search.Line2}` : ""}`,
        postcode: search.PostalCode,
        city: search.City,
        location: {
          lng: body.Items[0].Longitude,
          lat: body.Items[0].Latitude,
        },
      }),
    );
  };

  // Render
  return (
    <Formik
      //innerRef={formDetails}
      initialValues={{
        fullname: profile.fullname,
        email: user.email,
        practiceNumber: profile.practiceNumber,
        website: websiteURL,
        x: xURL,
        linkedIn: linkedInURL,
        youTube: youTubeURL,
        instagram: instagramURL,
        tiktok: tiktokURL,
        pronoun: profile?.pronoun[0]?.value,
      }}
      validationSchema={Yup.object({
        fullname: Yup.string().required("Full name required."),
        email: Yup.string().email().required("Contact email required."),
        website: Yup.string().nullable(),
        x: Yup.string().nullable(),
        linkedIn: Yup.string().nullable(),
        youTube: Yup.string().nullable(),
        instagram: Yup.string().nullable(),
        tiktok: Yup.string().nullable(),
        practiceNumber: Yup.string().matches(
          phoneRegExp,
          "Contact phone is not valid",
        ),
        mobileNumber: Yup.string()
          .matches(phoneRegExp, "Mobile number is not valid")
          .nullable(),
      })}
      onSubmit={() => {}}
    >
      {(formik) => (
        <div className="flex flex-col rounded items-start gap-6 w-full bg-white p-4">
          <div className="w-full flex flex-col gap-2">
            <FormItemTitle title="Your personal details" />
            <div className="flex flex-col sm:flex-row justify-between w-full sm:items-center">
              <div className="w-1/3 flex items-center">
                <Text>Pronouns</Text>
              </div>

              <div className="flex flex-1 items-center">
                <SelectInput
                  name="pronoun"
                  variant="outline"
                  placeholder="Prefer not to say"
                  onChange={(e) => {
                    formik.handleChange(e);
                    const value = utilityData?.pronoun.filter(
                      (item) => item.value === parseInt(e.target.value, 10),
                    );
                    handleProfileValueUpdate("pronoun", value);
                  }}
                >
                  {utilityData?.pronoun?.map((item, idx) => {
                    return (
                      <option key={idx} value={item.value}>
                        {item.label}
                      </option>
                    );
                  })}
                </SelectInput>
              </div>
            </div>

            {contactData.map((item) => (
              <div
                key={item.fieldName}
                className="flex flex-col sm:flex-row pt-2 sm:pt-0 justify-between sm:items-center"
              >
                <div className="w-full sm:w-1/3 flex items-center">
                  <FormItemTitle
                    title={item.label}
                    label={item.tooltip}
                    required={item.required}
                    isLabel
                  />
                </div>

                <div className="flex flex-1 items-center">
                  <TextInput
                    isDisabled={item.disabled}
                    width="100%"
                    name={item.fieldName}
                    type={item.fieldType}
                    placeholder={item.placeholder}
                    variant="outline"
                    onChange={(e) => {
                      if (item.disabled) {
                        return;
                      }

                      formik.handleChange(e);
                      if (item.isLinks) {
                        handleProfileValueUpdate(
                          item.fieldName,
                          {
                            url: e.target.value,
                            fieldName: "website",
                            label: "Website",
                          },
                          item.isLinks,
                        );
                        return;
                      }
                      handleProfileValueUpdate(item.fieldName, e.target.value);
                    }}
                  />
                </div>
              </div>
            ))}
            <div className="flex flex-col sm:flex-row justify-between items-start pt-2 sm:pt-0">
              <div className="w-full sm:w-1/3 flex items-center">
                <FormItemTitle
                  title="Contact address"
                  label="This address will not show up on your public profile unless you also enter it in the Session Hosting - In Person - Location section"
                  required
                  isLabel
                />
              </div>
              <div className="flex flex-1 flex-col w-full">
                <AddressSearch
                  locale="en-GB"
                  apiKey={process.env.NEXT_PUBLIC_LOQATE_APIKEY}
                  onSelect={(address) => {
                    setContactAddress(address);
                    loqateSearchAddress(address, false);
                  }}
                  countries={["GB", "GG", "IE", "IM", "JE"]}
                  components={searchListComponents}
                />
                {contactAddress && contactAddress.Line1 && (
                  <div className="flex flex-col gap-1 py-2 border-b">
                    <Input
                      className="p-2 rounded bg-gray-50 border-0"
                      value={contactAddress.Line1}
                      onChange={(e) =>
                        setContactAddress({
                          ...contactAddress,
                          Line1: e.target.value,
                        })
                      }
                    />
                    {contactAddress.Line2 && (
                      <Input
                        className="p-2 rounded bg-gray-50 border-0"
                        value={contactAddress.Line2}
                        onChange={(e) =>
                          setContactAddress({
                            ...contactAddress,
                            Line2: e.target.value,
                          })
                        }
                      />
                    )}
                    {contactAddress.Line3 && (
                      <Input
                        className="p-2 rounded bg-gray-50 border-0"
                        value={contactAddress.Line3}
                        onChange={(e) =>
                          setContactAddress({
                            ...contactAddress,
                            Line3: e.target.value,
                          })
                        }
                      />
                    )}
                    <Input
                      className="p-2 rounded bg-gray-50 border-0"
                      value={contactAddress.City}
                      onChange={(e) =>
                        setContactAddress({
                          ...contactAddress,
                          City: e.target.value,
                        })
                      }
                    />
                    <Input
                      className="p-2 rounded bg-gray-50 border-0"
                      value={contactAddress.PostalCode}
                      onChange={(e) =>
                        setContactAddress({
                          ...contactAddress,
                          PostalCode: e.target.value,
                        })
                      }
                    />
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="w-full flex flex-col gap-2">
            <FormItemTitle
              title="Your social media links"
              label="These will not show on your public profile"
            />
            {linksData.map((item) => (
              <div
                key={item.fieldName}
                className="flex justify-between items-center"
              >
                <div className="w-1/3 flex items-center">
                  <Text>{item.label}</Text>
                  {item.tooltip && (
                    <Tooltip hasArrow label={item.tooltip}>
                      <InfoIcon color="blue.200" marginLeft="4px" />
                    </Tooltip>
                  )}
                </div>

                <div className="flex flex-1 items-center">
                  <div className="mr-2">
                    {item.icon ?? <div className="w-4"></div>}
                  </div>
                  <TextInput
                    width="100%"
                    name={item.fieldName}
                    type={item.fieldType}
                    placeholder={item.placeholder}
                    variant="outline"
                    value={
                      urls.filter((link) => link.type === item.fieldName)[0]
                        ?.url
                    }
                    onChange={(e) => {
                      formik.handleChange(e);
                      handleProfileValueUpdate(
                        "links",
                        {
                          ...item,
                          url: e.target.value,
                        },
                        true,
                      );
                    }}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </Formik>
  );
};

export default ProfileContactForm;
